import BidLocationIcon from '../../elements/BidLocationIcon/BidLocationIcon'

export default function CardLocationLabel({ label, twcss, inCarousel }: any) {
  return (
    <div className={`flex items-center ${twcss || ''}`}>
      <BidLocationIcon fill="text-bidfta-gray-dark" />
      <span className={`ml-1 ${inCarousel ? 'text-xs' : 'text-8 md:text-xs'}`}>
        {label}
      </span>
    </div>
  )
}
